import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useConciergeUserAuth } from "../Auth/ConciergeUserAuthContext";

const navItems = [
  { to: "/concierge/manage/my", label: "내 컨시어지" },
  { to: "/concierge/manage/history", label: "컨시어지 히스토리" },
  { to: "/concierge/manage/payments", label: "결제 내역" },
  { to: "/concierge/manage/refunds", label: "환불 내역" },
];

export default function ConciergeUserLayout() {
  const navigate = useNavigate();
  const { me, logout } = useConciergeUserAuth();

  return (
    <div className="min-h-screen bg-[#f5f6f8] p-6">
      <div className="mx-auto max-w-[1480px] overflow-hidden rounded-[28px] bg-white shadow-[0_20px_60px_rgba(15,23,42,0.08)]">
        <div className="flex min-h-[calc(100vh-48px)]">
          <aside className="w-[260px] shrink-0 border-r border-[#eef1f6] bg-[#fbfbfc] px-6 py-8">
            <div className="text-[28px] font-black italic tracking-tight text-black">wizMarket</div>

            <div className="mt-8 rounded-2xl bg-[#f3f4f8] p-4">
              <div className="text-xs text-[#8b8f98]">사용자 정보</div>
              <div className="mt-2 text-sm font-semibold text-[#111827]">{me?.user_name || "컨시어지 사용자"}</div>
              <div className="mt-1 text-xs text-[#6b7280]">{me?.phone || ""}</div>
              <div className="mt-3 flex gap-2">
                <button
                  type="button"
                  onClick={() => navigate("/concierge/manage/change-pin")}
                  className="flex-1 rounded-lg border border-[#d9deea] bg-white px-3 py-2 text-xs text-[#4b5563]"
                >
                  핀번호 변경
                </button>
                <button
                  type="button"
                  onClick={() => {
                    logout();
                    navigate("/concierge/manage/login", { replace: true });
                  }}
                  className="flex-1 rounded-lg border border-[#d9deea] bg-white px-3 py-2 text-xs text-[#4b5563]"
                >
                  로그아웃
                </button>
              </div>
            </div>

            <nav className="mt-6 space-y-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      "block rounded-xl px-4 py-3 text-sm font-medium transition",
                      isActive
                        ? "bg-[#eef2ff] text-[#6157f8]"
                        : "text-[#374151] hover:bg-[#f3f4f6]",
                    ].join(" ")
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </aside>

          <div className="min-w-0 flex-1 bg-[#fcfcfd]">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

